import { mapActions, mapGetters } from 'vuex';

import offersMixin from './offers';
import servicesMixin from './services';

export default {
  mixins: [
    offersMixin,
    servicesMixin
  ],
  computed: {
    ...mapGetters({
      $m_cart_content: 'cart/getContent',
      $m_cart_isPathActive: 'cart/isPathActive',
      $m_cart_isPathDisabled: 'cart/isPathDisabled',
      $m_cart_isPathHidden: 'cart/isPathHidden',
      $m_cart_isPathSuspended: 'cart/isPathSuspended',
      $m_cart_getQuantity: 'cart/getItemQuantity'
    }),
    $m_cart_isChecked() {
      return this.$m_cart_isPathActive(this.path);
    },
    $m_cart_isDisabled() {
      return this.$m_cart_isPathDisabled(this.path);
    },
    $m_cart_isHidden() {
      return this.$m_cart_isPathHidden(this.path);
    },
    $m_cart_isSuspended() {
      return this.$m_cart_isPathSuspended(this.path);
    },
    $m_cart_itemQuantity() {
      return this.$m_cart_getQuantity(this.path);
    }
  },
  methods: {
    ...mapActions({
      $m_cart_storeUpdate: 'cart/update'
    }),
    isAdditionalService(item) {
      if (this.isExcludedFromBase(item.path)) {
        return true;
      }

      return (item.config.parent || this.servicesInclusionPaths.includes(item.path)) && !this.isIncludedInBase(item.path);
    },
    $m_cart_update(_item) {
      this.$m_cart_storeUpdate(_item).then(() => {
        if (_item.quantity > 0) {
          const offers = this.getEligibleOffers(_item.path);
          const targets = offers.map(offer => offer.subject.target);

          targets.forEach((target) => {
            if (target && !this.$m_cart_isPathActive(target)) {
              this.$m_cart_storeUpdate({
                path: target,
                quantity: _item.quantity > 0 ? 1 : 0,
                uniqueInNamespace: false,
                provenance: 'offer'
              });
            }
          });
        } else {
          const extraItems = this.$m_cart_content.filter(e => e.path === _item.path);

          if (extraItems.length && extraItems[0].relationships && extraItems[0].relationships.show) {
            extraItems[0].relationships.show.forEach((extra) => {
              this.$m_cart_storeUpdate({
                path: extra,
                quantity: 0,
                uniqueInNamespace: false
              });
            });
          } else if (extraItems[0].components && Object.keys(extraItems[0].components).length) {
            const additionalItems = this.$m_cart_content.filter(item => item.quantity && item.config.isListable && this.isAdditionalService(item));
            const contextualizedAdditionalItems = additionalItems.filter(item => item.path.includes(_item.path));

            contextualizedAdditionalItems.forEach((additionalItem) => {
              this.$m_cart_storeUpdate({
                path: additionalItem.path,
                quantity: 0,
                uniqueInNamespace: false
              });
            });
          }
        }

        const itemOffers = this.$m_cart_content.filter(item => item.provenance === 'offer');
        itemOffers.forEach((item) => {
          !this.isPathAnOffer(item.path) && this.$m_cart_storeUpdate({
            path: item.path,
            quantity: 0,
            uniqueInNamespace: false,
            provenance: 'manual'
          });
        });
      });
    },
    $m_cart_coverage_scrutiny(coverageType) {
      if ((coverageType === 'stv') || (coverageType === 'ftth')) {
        this.$gm_router_push('cobertura-contacto');
      } else if (coverageType === 'dst') {
        this.$m_cart_update({
          path: '_coverage_control.components.dst',
          quantity: 1,
          uniqueInNamespace: true
        });
      } else {
        this.$m_cart_update({
          path: '_coverage_control.components.nowo',
          quantity: 1,
          uniqueInNamespace: true
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/mixins/cart.js